import modStatChange from "./ModStatChange";
import { addGrant, removeGrant, shiftGranted } from "./QualityGrants";

const sameMod = (q, mod) => q.Key === mod.Key && (mod.Key || q.MiscDesc === mod.MiscDesc)

const editQualities = (item, qualities, remove, attachment) => {
    let moddedItem = JSON.parse(JSON.stringify(item))
    moddedItem.Qualities = moddedItem.Qualities || []
    const mods = JSON.parse(JSON.stringify([].concat(qualities || [])))
    const applyStat = (quality) => {
        let statMod
        [moddedItem, statMod] = modStatChange(moddedItem, quality, remove)
        moddedItem.Qualities = moddedItem.Qualities || []
        return statMod
    }
    const startRange = moddedItem.Range
    const skipKey = (q) => JSON.stringify({ ...q, Count: undefined })
    const gate = (quality, modI) => {
        if (!quality.IfRangeBlocked) return false
        const applied = [...(moddedItem.AppliedConditionals || [])]
        let skip
        if (remove) {
            const at = applied.indexOf(skipKey(quality))
            skip = at === -1
            if (!skip) { applied.splice(at, 1) }
        } else {
            const reduced = mods.slice(0, modI).some((m) => m.Key === "RANGESUB")
            skip = !reduced || moddedItem.Range !== startRange
            if (!skip) { applied.push(skipKey(quality)) }
        }
        if (applied.length) { moddedItem.AppliedConditionals = applied } else { delete moddedItem.AppliedConditionals }
        return skip
    }
    const scale = (quality) => {
        const mult = parseFloat(quality.WeaponCountDamageMult)
        if (!mult) return quality
        const { WeaponCountDamageMult, WeaponCountRound, ...rest } = quality
        const sig = "Scaled" + quality.Key + mult
        const scaled = { ...(moddedItem.ScaledCounts || {}) }
        const stack = [...(scaled[sig] || [])]
        let count
        if (remove && stack.length) {
            count = stack.pop()
        } else {
            const raw = (parseInt(moddedItem.Damage) || parseInt(moddedItem.DamageAdd) || 0) * mult
            count = Math.max(1, WeaponCountRound === "up" ? Math.ceil(raw) : Math.floor(raw))
            if (!remove) { stack.push(count) }
        }
        if (stack.length) { scaled[sig] = stack } else { delete scaled[sig] }
        if (Object.keys(scaled).length) { moddedItem.ScaledCounts = scaled } else { delete moddedItem.ScaledCounts }
        return { ...rest, Count: String(count) }
    }
    const shift = (quality, delta, index, recordDebt = true) => {
        const quals = moddedItem.Qualities
        if (index !== -1 && quals[index].Grants) {
            shiftGranted(quals[index], delta)
            return
        }
        const debtKey = "Qual" + (quality.Key || quality.MiscDesc)
        const debt = { ...(moddedItem.ClampDebt || {}) }
        let count = index === -1 ? 0 : (parseInt(quals[index].Count) || 0)
        if (delta > 0 && debt[debtKey]) {
            const paid = Math.min(debt[debtKey], delta)
            debt[debtKey] -= paid
            delta -= paid
        }
        count += delta
        if (count < 0) {
            if (recordDebt) { debt[debtKey] = (debt[debtKey] || 0) - count }
            count = 0
        }
        if (count === 0) { if (index !== -1) quals.splice(index, 1) }
        else if (index === -1) { quals.push({ ...quality, Count: String(count) }) }
        else { quals[index].Count = String(count) }
        Object.keys(debt).forEach(k => { if (!debt[k]) delete debt[k] })
        if (Object.keys(debt).length) { moddedItem.ClampDebt = debt } else { delete moddedItem.ClampDebt }
    }

    if (remove) {
        // Remove qualities
        mods.forEach((rawQuality, modI) => {
            if (gate(rawQuality, modI)) return
            const quality = scale(rawQuality)
            const quals = moddedItem.Qualities
            const existingQualityIndex = quals.findIndex((q) => sameMod(q, quality));
            if (quality.QualSet && quality.Count && existingQualityIndex !== -1 && quals[existingQualityIndex].Grants) {
                const total = removeGrant(quals[existingQualityIndex], quality.Count)
                if (total !== null) {
                    quals[existingQualityIndex].Count = "0"
                    shift(quality, total, existingQualityIndex)
                }
                return
            }
            if (existingQualityIndex !== -1) {
                const existingQuality = quals[existingQualityIndex];
                if ((quality.QualReplace || quality.QualSet) && existingQuality.PreSetCount !== undefined) {
                    if (existingQuality.SetDepth > 1) {
                        existingQuality.SetDepth -= 1
                        if (existingQuality.SetDepth === 1) { delete existingQuality.SetDepth }
                    } else {
                        existingQuality.Count = existingQuality.PreSetCount
                        delete existingQuality.PreSetCount
                    }
                } else if (quality.Count) {
                    let amount = quality.Count
                    if (quality.NewCount && existingQuality.NewCountAdds) {
                        existingQuality.NewCountAdds -= 1
                        if (!existingQuality.NewCountAdds) { delete existingQuality.NewCountAdds }
                    } else if (quality.NewCount && existingQuality.NewCount) {
                        amount = quality.NewCount
                    }
                    shift(quality, -(parseInt(amount) || 0), existingQualityIndex)
                    if (quality.Key === "SUPERIOR" && !moddedItem.Qualities.some((q) => q.Key === "SUPERIOR")) { applyStat(quality) }
                    return
                } else if (existingQuality.Stacked) {
                    existingQuality.Stacked -= 1
                    if (!existingQuality.Stacked) { delete existingQuality.Stacked }
                    return
                }
                if (!existingQuality.Count || parseInt(existingQuality.Count) <= 0) {
                    quals.splice(existingQualityIndex, 1);
                }
                if (quality.Key === "SUPERIOR") { applyStat(quality) }
            } else {
                const statMod = applyStat(quality)
                if (!statMod && quality.Key && parseInt(quality.Count) < 0) {
                    shift({ Key: quality.Key }, -parseInt(quality.Count), -1, false)
                }
            }
        });
    } else {
        // Add or update qualities
        mods.forEach((rawQuality, modI) => {
            if (gate(rawQuality, modI)) return
            const quality = scale(rawQuality)
            const quals = moddedItem.Qualities
            const existingQualityIndex = quals.findIndex((q) => sameMod(q, quality));
            if (quality.QualSet && quality.Count && quality.Key) {
                if (existingQualityIndex !== -1) {
                    addGrant(quals[existingQualityIndex], quality.Count)
                } else {
                    const { QualSet, ...entry } = quality
                    if (attachment) { entry.FromAttachment = quality.Count }
                    quals.push(addGrant({ ...entry, Count: "0" }, quality.Count))
                }
                return
            }
            if (existingQualityIndex !== -1) {
                const existingQuality = quals[existingQualityIndex];
                if (quality.Count) {
                    if (quality.QualReplace || quality.QualSet) {
                        if (existingQuality.PreSetCount === undefined) { existingQuality.PreSetCount = existingQuality.Count }
                        else { existingQuality.SetDepth = (existingQuality.SetDepth || 1) + 1 }
                    }
                    if (quality.NewCount) { existingQuality.NewCountAdds = (existingQuality.NewCountAdds || 0) + 1 }
                    if (quality.QualReplace) {
                        existingQuality.Count = quality.Count
                    } else if (quality.QualSet) {
                        existingQuality.Count = String(Math.max(parseInt(quality.Count), parseInt(existingQuality.Count)))
                    } else {
                        shift(quality, parseInt(quality.Count) || 0, existingQualityIndex)
                    }
                } else {
                    existingQuality.Stacked = (existingQuality.Stacked || 0) + 1
                }
            } else {
                // Quality doesn't exist, add it
                if (quality.NewCount) {
                    quality.Count = quality.NewCount
                }
                if (attachment) { quality.FromAttachment = (quality.Count || true) }
                const statMod = applyStat(quality)
                if (quality.Key === "ENCTADD" && attachment) { }
                else if (!statMod && quality.Key && parseInt(quality.Count) < 0) {
                    shift({ Key: quality.Key }, parseInt(quality.Count), -1)
                }
                else if (quality.Key === "SUPERIOR" || !statMod) {
                    moddedItem.Qualities.push(quality)
                }
            }
        });
    }

    moddedItem.Qualities = JSON.parse(JSON.stringify(moddedItem.Qualities))
    return moddedItem;
};

export default editQualities
